import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageMeta from '@/components/base/PageMeta';

const strengths = [
  {
    icon: 'ri-database-2-line',
    title: '海量数据库',
    description: '累计收录超过12万条爆料信息，覆盖娱乐圈95%以上的热点事件，是全网最大的黑料资讯库。',
  },
  {
    icon: 'ri-team-line',
    title: '专业编辑团队',
    description: '30+资深娱乐记者和编辑组成的专业团队，确保每一条爆料的准确性和专业性。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速响应',
    description: '7x24小时实时监控，热点事件平均5分钟内完成首报，永远比别人快一步。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '信息核验',
    description: '独创三重核验机制：信源核实、交叉验证、事实比对，从源头保证内容质量。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '用户至上',
    description: '890万注册用户的选择，用户满意度高达96.8%，是吃瓜群众最信赖的平台。',
  },
  {
    icon: 'ri-global-line',
    title: '全网覆盖',
    description: '与200+娱乐媒体和行业KOL保持合作关系，信息网络覆盖微博、抖音、小红书等全平台。',
  },
];

const reviews = [
  {
    name: '资深吃瓜群众 — 小王',
    quote: '我从2021年就开始关注51黑料吃瓜网了，可以说见证了这个平台从一个小网站成长为现在全网最大的爆料平台。最喜欢他们的深度起底系列，信息量大还很有趣，每天不刷一遍都感觉少了点什么。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20trendy%20young%20Chinese%20person%20in%20dramatic%20warm%20lighting%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20simple%20warm%20background%2C%20confident%20and%20friendly%20expression&width=600&height=750&seq=about-review-01&orientation=portrait',
  },
  {
    name: '娱乐圈从业者 — 李明',
    quote: '作为一个在娱乐圈工作多年的人，我不得不说51爆料网的信息准确率确实比同行高出一大截。很多所谓的独家爆料在他们这里都能找到更接近真相的版本，这对我们从业者来说是非常有价值的参考。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20professional%20Chinese%20man%20in%20dramatic%20warm%20lighting%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20simple%20dark%20background%2C%20thoughtful%20expression&width=600&height=750&seq=about-review-02&orientation=portrait',
  },
  {
    name: '大学生 — 小芳',
    quote: '我们宿舍四个人都是51黑料吃瓜网的忠实用户！每天晚上熄灯后最大的乐趣就是一起刷最新的爆料，讨论八卦。虽然有时候被人说是"吃瓜群众"，但大家一起吃瓜的快乐是真的！',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20young%20Chinese%20woman%20student%20in%20dramatic%20warm%20lighting%2C%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20simple%20warm%20background%2C%20cheerful%20expression&width=600&height=750&seq=about-review-03&orientation=portrait',
  },
];

export default function AboutPage() {
  const [reviewIdx, setReviewIdx] = useState(0);
  const r = reviews[reviewIdx];
  const goNext = () => setReviewIdx((prev) => (prev + 1) % reviews.length);
  const goPrev = () => setReviewIdx((prev) => (prev - 1 + reviews.length) % reviews.length);

  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('submitting');
    setFormError('');

    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="company_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      form.reset();
      return;
    }

    const formData = new FormData(form);
    formData.delete('company_alt');

    try {
      const res = await fetch('https://readdy.ai/api/form/d95mgeea5sk3luk4pg8g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }

      if (res.ok && (parsed as { code?: string }).code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg = (parsed as { meta?: { message?: string } })?.meta?.message
          || (parsed as { message?: string })?.message
          || '提交失败，请稍后再试';
        setFormError(msg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于51黑料吃瓜网',
    description: '51黑料吃瓜网是国内领先的娱乐资讯爆料平台，汇聚全网海量网红明星黑料、娱乐圈八卦与独家爆料资源。',
    publisher: {
      '@type': 'Organization',
      name: '51黑料吃瓜网',
      url: 'https://51heiliaochigua.com',
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://51heiliaochigua.com' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://51heiliaochigua.com/about' },
    ],
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51黑料吃瓜网如何保证爆料信息的真实性？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51黑料吃瓜网采用独创的三重核验机制：信源核实、交叉验证和事实比对。每条爆料发布前都经过编辑团队的严格审核，确保信息的准确性和可靠性。',
        },
      },
      {
        '@type': 'Question',
        name: '如何与51爆料网进行商务合作？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '欢迎通过页面底部的商务合作表单联系我们，或直接发送邮件至contact@51heiliaochigua.com。我们的商务团队会在24小时内与您取得联系。',
        },
      },
    ],
  };

  return (
    <>
      <PageMeta
        title="关于我们 - 51黑料吃瓜网 | 51爆料网"
        description="了解51黑料吃瓜网的品牌故事、平台实力和联系方式。我们致力于为吃瓜群众提供最新最全的娱乐圈爆料资讯，890万用户的选择。"
        keywords="关于51黑料吃瓜网,51爆料网介绍,吃瓜平台,娱乐爆料,商务合作"
        canonical="https://51heiliaochigua.com/about"
        ogTitle="关于我们 - 51黑料吃瓜网"
        ogDescription="了解51黑料吃瓜网的品牌故事、平台实力和联系方式。890万吃瓜群众的选择。"
        ogUrl="https://51heiliaochigua.com/about"
        jsonLdScripts={[aboutJsonLd, breadcrumbJsonLd, faqJsonLd]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <nav className="pt-20 md:pt-28 px-6 md:px-10 max-w-6xl mx-auto" aria-label="面包屑导航">
          <ol className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
            <li><Link to="/" className="hover:text-foreground-950 transition-colors">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-[10px]"></i></li>
            <li className="text-foreground-950 font-medium">关于我们</li>
          </ol>
        </nav>

        <main>
          {/* Brand Intro */}
          <section className="w-full pt-8 md:pt-12 pb-12 md:pb-20">
            <div className="w-full px-6 md:px-10 max-w-4xl mx-auto">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full font-label mb-6">
                关于我们
              </span>

              <h1 className="text-4xl md:text-7xl font-heading font-bold text-foreground-950 leading-tight mb-10">
                全网最全
                <br />
                吃瓜第一阵地
                <br />
                <span className="relative inline-block">
                  51黑料
                  <span className="absolute -right-4 md:-right-6 top-0 w-6 h-6 md:w-8 md:h-8 rounded-full overflow-hidden inline-flex items-center">
                    <img
                      src="https://readdy.ai/api/search-image?query=Cinematic%20closeup%20of%20a%20warm%20glowing%20spotlight%20on%20a%20dark%20stage%2C%20film%20grain%20texture%2C%20dramatic%20golden%20light%2C%20editorial%20photography%2C%20mysterious%20vibe&width=80&height=80&seq=about-brand-01&orientation=squarish"
                      alt="51黑料吃瓜网品牌"
                      className="w-full h-full object-cover rounded-full"
                    />
                  </span>
                </span>
                吃瓜网
              </h1>

              <div className="flex items-center gap-3 mb-12 flex-wrap">
                <Link
                  to="/category/star-scandal"
                  className="px-7 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap font-label"
                >
                  开始吃瓜
                </Link>
                <a
                  href="#contact"
                  className="px-7 py-3 border-2 border-foreground-200 text-foreground-950 text-sm font-medium rounded-full hover:border-foreground-400 transition-colors duration-200 whitespace-nowrap font-label"
                >
                  联系我们
                </a>
              </div>

              <div className="max-w-2xl">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  51黑料吃瓜网（51爆料网）成立于2020年，是国内领先的娱乐资讯爆料平台。我们汇聚全网海量网红明星黑料、娱乐圈八卦与独家爆料资源，致力于为每一位吃瓜群众提供最新、最全、最真实的娱乐资讯服务。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4">
                  平台拥有一支专业的编辑团队和广泛的信息网络，24小时不间断监控全网热点动态，第一时间为读者推送最新大瓜。我们坚持"真实、深度、有趣"的内容理念，每一条爆料都经过严格的交叉验证，确保信息的可靠性和可读性。
                </p>
              </div>
            </div>
          </section>

          {/* Platform Strength */}
          <section className="w-full py-16 md:py-24 bg-background-100">
            <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
              <p className="text-xs font-medium text-secondary-500 uppercase tracking-widest font-label mb-3">
                我们的实力
              </p>
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-12 md:mb-16">
                平台数据
                <br />
                用实力说话
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {strengths.map((item) => (
                  <div
                    key={item.title}
                    className="bg-background-100 rounded-xl p-6 md:p-8 hover:bg-background-200/60 transition-colors duration-300"
                  >
                    <div className="w-10 h-10 flex items-center justify-center mb-5">
                      <i className={`${item.icon} text-2xl text-foreground-950`}></i>
                    </div>
                    <h3 className="text-lg font-bold text-foreground-950 mb-3 font-heading">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* User Testimonials */}
          <section className="w-full py-16 md:py-24 bg-background-100">
            <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
                <div className="w-full lg:w-2/5">
                  <div className="relative rounded-2xl overflow-hidden bg-accent-100" style={{ aspectRatio: '4/5' as string }}>
                    <img
                      src={r.image}
                      alt={`用户 ${r.name}`}
                      title="51黑料吃瓜网 - 用户口碑"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="w-full lg:w-3/5 flex flex-col justify-center">
                  <span className="text-xs font-medium text-secondary-500 uppercase tracking-widest font-label mb-3">
                    （用户口碑）
                  </span>
                  <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-8">
                    来自用户
                    <br />
                    <span className="text-foreground-300">的真实声音</span>
                  </h2>

                  <blockquote className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6 italic">
                    &ldquo;{r.quote}&rdquo;
                  </blockquote>

                  <p className="text-sm font-bold text-foreground-950 font-heading">
                    — {r.name}
                  </p>

                  <div className="flex items-center gap-3 mt-8">
                    <button
                      onClick={goPrev}
                      className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:text-foreground-950 hover:border-foreground-400 transition-colors duration-200 cursor-pointer"
                    >
                      <i className="ri-arrow-left-line"></i>
                    </button>
                    <button
                      onClick={goNext}
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors duration-200 cursor-pointer"
                    >
                      <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Contact Section */}
          <section id="contact" className="w-full py-16 md:py-24 bg-background-50">
            <div className="w-full px-6 md:px-10 max-w-3xl mx-auto">
              <div className="text-center mb-10 md:mb-14">
                <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full font-label mb-4">
                  商务合作
                </span>
                <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
                  与我们取得联系
                </h2>
                <p className="text-sm text-foreground-600 mt-3 max-w-md mx-auto">
                  无论您是媒体合作、广告投放还是投稿爆料，欢迎随时联系我们
                </p>
              </div>

              <div className="bg-background-100 rounded-2xl p-6 md:p-10">
                <form
                  onSubmit={handleContactSubmit}
                  data-readdy-form
                  className="space-y-5"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-xs font-medium text-foreground-700 mb-1.5 font-label">
                        姓名 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-foreground-400 transition-colors text-foreground-950 placeholder-foreground-400"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-foreground-700 mb-1.5 font-label">
                        邮箱 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-foreground-400 transition-colors text-foreground-950 placeholder-foreground-400"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-foreground-700 mb-1.5 font-label">
                      合作类型 <span className="text-primary-500">*</span>
                    </label>
                    <select
                      name="cooperation_type"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-foreground-400 transition-colors text-foreground-950 cursor-pointer"
                    >
                      <option value="">请选择合作类型</option>
                      <option value="media">媒体合作</option>
                      <option value="advertising">广告投放</option>
                      <option value="tip">投稿爆料</option>
                      <option value="other">其他合作</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-foreground-700 mb-1.5 font-label">
                      留言内容 <span className="text-primary-500">*</span>
                    </label>
                    <textarea
                      name="message"
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-foreground-400 transition-colors text-foreground-950 placeholder-foreground-400 resize-none"
                      placeholder="请详细描述您的合作需求（限500字）"
                    ></textarea>
                    <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
                  </div>

                  <div className="form-hp-wrapper">
                    <input
                      type="text"
                      name="company_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                  </div>

                  {formStatus === 'success' && (
                    <div className="p-4 bg-accent-50 text-accent-700 text-sm rounded-lg">
                      提交成功！我们会在24小时内与您取得联系。
                    </div>
                  )}
                  {formStatus === 'error' && formError && (
                    <div className="p-4 bg-primary-50 text-primary-700 text-sm rounded-lg">
                      {formError}
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={formStatus === 'submitting'}
                    className="w-full px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap font-label cursor-pointer"
                  >
                    {formStatus === 'submitting' ? '提交中...' : '提交留言'}
                  </button>
                </form>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-10">
                <div className="text-center p-5 bg-background-100 rounded-xl">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center">
                    <i className="ri-phone-line text-xl text-foreground-950"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">电话</p>
                  <p className="text-sm font-medium text-foreground-950">400-888-8888</p>
                </div>
                <div className="text-center p-5 bg-background-100 rounded-xl">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center">
                    <i className="ri-mail-line text-xl text-foreground-950"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">邮箱</p>
                  <p className="text-sm font-medium text-foreground-950">contact@51heiliaochigua.com</p>
                </div>
                <div className="text-center p-5 bg-background-100 rounded-xl">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center">
                    <i className="ri-map-pin-line text-xl text-foreground-950"></i>
                  </div>
                  <p className="text-xs text-foreground-500 mb-1">地址</p>
                  <p className="text-sm font-medium text-foreground-950 leading-snug">北京市朝阳区星光大道88号</p>
                </div>
              </div>
            </div>
          </section>

          {/* Join CTA */}
          <section className="w-full py-16 md:py-24 bg-background-100">
            <div className="w-full px-6 md:px-10 max-w-4xl mx-auto flex flex-col items-center text-center">
              <div className="w-full rounded-2xl overflow-hidden mb-10 md:mb-14">
                <div className="relative w-full" style={{ aspectRatio: '16/7' as string }}>
                  <img
                    src="https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20vibrant%20social%20media%20community%20gathering%2C%20abstract%20representation%20of%20people%20sharing%20news%20and%20information%2C%20warm%20golden%20hour%20lighting%2C%20soft%20film%20grain%2C%20modern%20editorial%20photography%2C%20diverse%20crowd%20silhouettes%20connected%20by%20glowing%20threads%2C%20cinematic%20color%20grading%20with%20warm%20amber%20and%20rose%20tones%2C%20atmospheric%20depth&width=1600&height=700&seq=about-join-bg&orientation=landscape"
                    alt="51黑料吃瓜网 - 加入吃瓜社区"
                    title="51黑料吃瓜网 - 加入我们"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/15 to-transparent"></div>
                </div>
              </div>

              <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
                加入我们
              </h2>
              <p className="text-xl md:text-2xl font-heading italic text-foreground-400 font-light mb-2">
                做最前排的吃瓜群众
              </p>
              <p className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-10 md:mb-12">
                一起吃遍天下大瓜
              </p>

              <Link
                to="/category/influencer-gossip"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap font-label"
              >
                立即围观
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}